import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDate as getDate } from '../../../hooks';
import Countdown, { zeroPad } from 'react-countdown';

import './concertDetailedBanner.scss';

const ConcertDetailedBanner = ({ concertDetails, options }) => {
  const {
    date,
    time12,
    title,
    artists,
    location: place,
    country,
    to_be_confirmed,
  } = concertDetails !== undefined && concertDetails;

  const { timezone, showCountdown } = options !== undefined && options;

  const conductor = artists && artists.filter((el) => el.role === 'conductor');
  const soloists = artists && artists.filter((el) => el.role === 'soloist');
  const { day, month } = getDate(date);

  return (
    <>
      <div className='concert__banner'>
        {showCountdown ? (
          <div className='dates'>
            <Countdown
              date={new Date(
                `${date}T${concertDetails.time}:00`
              ).toLocaleString('en-US', { timeZone: timezone })}
              renderer={({ days, hours, minutes, seconds, ...props }) => {
                return (
                  <>
                    <h4 className='date countdown__value my-3 my-lg-0'>
                      <span>
                        {zeroPad(days)}
                        <span className='label'>DD</span>
                      </span>
                      :
                      <span>
                        {zeroPad(hours)}
                        <span className='label'>HH</span>
                      </span>
                      :
                      <span>
                        {zeroPad(minutes)}
                        <span className='label'>MM</span>
                      </span>
                      :
                      <span>
                        {zeroPad(seconds)}
                        <span className='label'>SS</span>
                      </span>
                    </h4>
                  </>
                );
              }}
            />
          </div>
        ) : (
          concertDetails && (
            <div className='dates'>
              {to_be_confirmed ? (
                <h4 className='date'>TBC</h4>
              ) : (
                <>
                  <h4 className='date'>
                    {day || ''} {month || ''}
                  </h4>
                  START
                  <span className='time'>{time12 || ''}</span>
                </>
              )}
            </div>
          )
        )}

        <div className='text'>
          <h1 className='title' dangerouslySetInnerHTML={{ __html: title }} />
          <h3 className='subtitle'>
            {artists &&
              artists.map(
                (orc, i) =>
                  orc.role === 'orchestra' && (
                    <Fragment key={i}>
                      {orc.name} <br />
                    </Fragment>
                  )
              )}
          </h3>
        </div>

        <div className='artists'>
          {conductor && conductor.length ? (
            <>
              <div className='conductor__parent'>
                <span className='artist__title'>CONDUCTOR:</span>

                {conductor.map((con, i) => (
                  <div className='conductor' key={i}>
                    <div className='conductor__avatar'>
                      <img
                        src={con.avatar}
                        alt={`${con.name} ${con.surname} img`}
                      />
                    </div>
                    <h6
                      dangerouslySetInnerHTML={{
                        __html: `${con.name} ${con.surname}`,
                      }}
                      className='conductor__text'
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            ''
          )}
          {soloists && soloists.length !== 0 ? (
            <div className='soloists__parent'>
              <span className='artist__title'>
                soloist{soloists.length > 1 ? 's' : ''}:
              </span>
              <div className='soloists'>
                {soloists.length &&
                  soloists.map((soloist, i) => (
                    <div key={i} className='soloist'>
                      <div className='soloist__avatar'>
                        <img
                          src={soloist.avatar}
                          alt={`${soloist.name} ${soloist.surname}`}
                        />
                      </div>
                      <h6
                        dangerouslySetInnerHTML={{
                          __html: `${soloist.name} ${soloist.surname}`,
                        }}
                        className='soloist__text'
                      />
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>

        <div className='location'>
          <span className='place'>{place && place}</span>
          <p>{country && country}</p>
        </div>
      </div>
    </>
  );
};

ConcertDetailedBanner.propTypes = {
  concertDetails: PropTypes.object,
  options: PropTypes.object,
};

export default ConcertDetailedBanner;
